import { BaseService } from "./BaseService";
const config = require("../../config.js");
import { CognitoUser } from "amazon-cognito-identity-js";

interface GetRewardDetailsProps {
  propertyId: string | number;
  accountingId: string | number;
}

interface UpdateRewardProps {
  propertyId: string | number;
  accountingId: string | number;
  ledgerItemId: string | number;
  body: any;
}

interface ClaimRewardProps {
  propertyId: string | number;
  accountingId: string | number;
  body?: any;
}

interface RedeemRewardProps {
  propertyId: string | number;
  accountingId: string | number;
  body?: any;
}

export class RewardsService extends BaseService {
  constructor(
    public cognitoUser: CognitoUser,
    public dispatch = (any: any) => {},
    public url = config.rewardService
  ) {
    super(url, cognitoUser, dispatch);
  }

  async getUserAppState(propertyId?: string, accountingId?: string) {
    const url = `account/${propertyId}/${accountingId}`;
    return this.makeGetRequest(url, true);
  }

  async getRewardDetails(data: GetRewardDetailsProps) {
    const { accountingId, propertyId } = data;
    const url = `account/${propertyId}/${accountingId}`;
    return this.makeGetRequest(url, true);
  }

  async updateReward(data: UpdateRewardProps) {
    const { propertyId, accountingId, ledgerItemId, body } = data;
    const url = `account/${propertyId}/${accountingId}/${ledgerItemId}`;
    return this.makePostRequest(url, body, true);
  }
  async claimReward(data: ClaimRewardProps) {
    const { propertyId, accountingId, body } = data;
    const url = `claim/${propertyId}/${accountingId}`;
    return this.makePostRequest(url, body, true);
  }

  async redeemReward(data: RedeemRewardProps) {
    const { propertyId, accountingId, body } = data;
    const url = `redeem/${propertyId}/${accountingId}`;
    return this.makePostRequest(url, body, true);
  }

  async getRewardHistory(propertyId: string, accountingId: string) {
    const url = `history/${propertyId}/${accountingId}`;
    return this.makeGetRequest(url, true);
  }
}
